import { Pipe, PipeTransform, SecurityContext } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({ name: "notificationPreview", standalone: true, pure: true })
export class NotificationPreviewPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(message: string | null): string {
    const template = document.createElement("template");
    template.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, message ?? "") ?? "";

    // Separate HTML blocks in the plain-text preview without placing links inside a button.
    template.content.querySelectorAll("br").forEach(element => element.replaceWith(document.createTextNode(" ")));
    template.content.querySelectorAll("p, div, li, h1, h2, h3, h4, h5, h6").forEach(element => {
      element.append(document.createTextNode(" "));
    });
    return (template.content.textContent ?? "").replace(/\s+/g, " ").trim();
  }
}
